module.exports = __webpack_public_path__ + "img/bn0718.90b33511.png";